export default __webpack_public_path__ + "static/media/Legendary__xvid.d534466a.mp4";